// Конфигурация для разных типов образования
export const COURSE_TYPE_CONFIG = {
  // Основное образование
  0: {
    name: 'Основное',
    showTeacher: false,
    tableColumns: ['title', 'nr', 'hrs', 'expected_results', 'exercises']
  },
  // Дополнительное образование
  1: {
    name: 'Дополнительное',
    showTeacher: true,
    tableColumns: ['title', 'nr', 'hrs', 'expected_results']
  },
  // Внеурочная деятельность
  2: {
    name: 'Внеурочная деятельность',
    showTeacher: true,
    tableColumns: ['title', 'nr', 'hrs', 'expected_results']
  }
};

export const TABLE_COLUMNS = {
  title: { key: 'title', header: 'Название', maxLength: 250, multiline: true },
  nr: { key: 'nr', header: '№ урока', maxLength: 3 },
  hrs: { key: 'hrs', header: 'Кол-во часов', maxLength: 3 },
  expected_results: { key: 'expected_results', header: 'Планируемые результаты', maxLength: 250, multiline: true },
  exercises: { key: 'exercises', header: 'Упражнения', maxLength: 250 }
};

// Моковые данные для тестирования
export const MOCK_DATA = [
  {
    oid: 1,
    title: 'Информация вокруг нас',
    nr: 1,
    hrs: 2,
    expected_results: 'Понимание основ информатики',
    exercises: 'Упр. 1-5',
    level: 0,
    children: [
      {
        oid: 11,
        title: 'Что такое информация',
        nr: '1.1',
        hrs: 1,
        expected_results: 'Определение информации',
        exercises: 'Упр. 1-2',
        level: 1,
        children: []
      },
      {
        oid: 12,
        title: 'Виды информации',
        nr: '1.2',
        hrs: 1,
        expected_results: 'Классификация информации',
        exercises: 'Упр. 3-5',
        level: 1,
        children: []
      }
    ]
  },
  {
    oid: 2,
    title: 'Компьютер - универсальная машина для работы с информацией',
    nr: 2,
    hrs: 3,
    expected_results: 'Знание устройства компьютера',
    exercises: 'Упр. 6-10',
    level: 0,
    children: []
  },
  {
    oid: 3,
    title: 'Ввод информации в память компьютера',
    nr: 3,
    hrs: 2,
    expected_results: 'Навыки ввода данных',
    exercises: 'Упр. 11-15',
    level: 0,
    children: []
  },
  {
    oid: 4,
    title: 'Управление компьютером',
    nr: 4,
    hrs: 2,
    expected_results: 'Работа с ОС',
    exercises: 'Упр. 16-20',
    level: 0,
    children: []
  },
  {
    oid: 5,
    title: 'Хранение информации',
    nr: 5,
    hrs: 1,
    expected_results: 'Понимание носителей данных',
    exercises: 'Упр. 21-23',
    level: 0,
    children: []
  },
  {
    oid: 6,
    title: 'Передача информации',
    nr: 6,
    hrs: 1,
    expected_results: 'Каналы передачи данных',
    exercises: 'Упр. 24-26',
    level: 0,
    children: []
  },
  {
    oid: 7,
    title: 'Электронная почта. Практическая работа «Работаем с электронной почтой»',
    nr: 7,
    hrs: 2,
    expected_results: 'Навыки работы с email',
    exercises: 'Практ. работа',
    level: 0,
    children: []
  },
  {
    oid: 8,
    title: 'В мире кодов. Способы кодирования информации',
    nr: 8,
    hrs: 2,
    expected_results: 'Понимание кодирования',
    exercises: 'Упр. 27-30',
    level: 0,
    children: []
  }
];
